export function getEntityInitials(name: string): string {
  const [firstWord = ''] = name.trim().split(/\s+/);
  const letters = firstWord.match(/\p{L}|\p{N}/gu)?.join('') ?? '';

  return `${letters.slice(0, 1).toUpperCase()}${letters.slice(1, 2).toLowerCase()}`;
}
